import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[luiResourceCarouselSlide]',
    standalone: false
})
export class ResourceCarouselSlideDirective {
  constructor(public template: TemplateRef<ResourceCarouselSlideDirective>) {}
}
